import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import RankList from "@/pages/home/components/RankList";
import DoubanPicks from "@/pages/home/components/DoubanPicks";
import GenreExplorer from "@/pages/home/components/GenreExplorer";
import SpotlightSection from "@/pages/home/components/SpotlightSection";
import ScoringGuide from "@/pages/home/components/ScoringGuide";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <RankList />
        <DoubanPicks />
        <GenreExplorer />
        <SpotlightSection spotlightKey="action" sectionId="action" background="base" />
        <SpotlightSection spotlightKey="romance" sectionId="romance" background="alt" reverse />
        <SpotlightSection spotlightKey="horror" sectionId="horror" background="base" />
        <ScoringGuide />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}